import { EmojiIndex } from 'emoji-mart-vue-fast/src';
import data from 'emoji-mart-vue-fast/data/google.json';

// building the index walks the whole emoji set (tens of ms), so it is built once per app, on the first picker open
let emojiIndex = null;

export const getEmojiIndex = () => {
  if (!emojiIndex) {
    emojiIndex = new EmojiIndex(data);
  }
  return emojiIndex;
};
